
import TagCard from '~/components/banner-block/TagCard.vue';
import SliderImages from "~/components/planirovki/SliderImages.vue";

export default {
    name: 'MessageImage',

    components: {
      TagCard,
      SliderImages,
    },

    props: {
        title: {
            type: String,
            default: '',
        },

        category: {
            type: Object,
            default: () => ({}),
        },
        filters: {
            type: Array,
            default: () => [],
        },

        imageContain: {
            type: Boolean,
            default: false,
        },
      imagesCategory: {
            type: Array,
            default: () => {
              return []
            },
        },
    },

    computed: {
        message() {
            return this.category?.text || '';
        },

        vars() {
            return this.$store.state?.appState?.vars || {};
        },
        fullAddress() {
            return this.vars?.['Полный адрес'];
        },
        plosad() {
            const variants = (this.filters || []).find((t) => t.slug === 'plosad')?.variants || [];
            if (variants.length <= 0) {
                return null;
            }

            const minVariant = Math.min(...variants.map((t) => Number.parseFloat(t.label)));
            const maxVariant = Math.max(...variants.map((t) => Number.parseFloat(t.label)));

            return `${minVariant} - ${maxVariant} м2`;
        },
        price() {
          return ''

            const variants = (this.filters || []).find((t) => t.slug === 'cena')?.variants || [];
            if (variants.length <= 0) {
                return null;
            }

            const minVariant = Math.min(...variants.map((t) => Number.parseFloat(t.label)));
            const word = this.$caseWords(minVariant, [
                'рубля', 'рублей', 'рублей',
            ]);

            return `от ${this.$numberFormat(minVariant)} ${word}`;
        },
        tags: function() {
          return this.category?.dynamicFields?.tags || [];
        },
    },

    methods: {
        openPopUpImages(images) {
            const imagesToPopupStore = images && images.length > 0 ? images : [this.category.imageId];
            this.$store.commit('pop-up-images/setImages', imagesToPopupStore);
        },
    },
};
